const en = {
  // Navigation & General
All: "All",
SearchPublishedLawImplementations:"Search Published Law Implementations",
Back: "Back",
View: "View",
Action: "Action",
Cancel: "Cancel",
Save: "Save",
SaveChanges: "Save Changes",
Submit: "Submit",
Submitting: "Submitting...",
Refresh: "Refresh",
Note: "Note",
Remark: "Remark",
Date: "Date",
DraftSummary: "Draft Summary",
NoLetterReferenceNumberYet: "No letter reference number yet.",
CompletionLetterUploaded: "Completion letter uploaded",
Uploading: "Uploading...",
StakeholderName: "Stakeholder Name",
AppliedDate: "Applied Date",
AssignedTo: "Assigned To",
FeedbackSection: "Feedback Section",
RespondBackSection: "Respond Back Section",
CommentedDate: "Commented Date",
WriteBackResponseHere: "Write Back Response here",
Status: "Status",
Title: "Title",
Name: "Name",
Forward: "Forward",
ForwardToHead: "Forward to Head",
ForwardToStakeholder: "Forward to Stakeholder",
WriteHere: "Write here...",
ConfirmForward: "Confirm Forward",
ConfirmForwardMessage: "Are you sure you want to forward this request? This action cannot be undone.",
Researches: "Researches",
ConductLegalResearch: "Conduct Legal Research",
LegislativeDrafting: "Legislative Drafting",
LegalAdvisory: "Legal Advisory",
LawImplementation: "Law Implementation",
LegalAwarenessCreation: "Legal Awareness Creation",
LegalTrainingProvision: "Legal Training Provision",
LegalTranslation: "Legal Translation",
ConductLegislativeRequest: "Conduct Legislative Request",
RequestLegislativeLetterNumber: "Request Legislative Letter Number",
RegisterDirective: "Register Directive",
SectorDirectives: "Sector Directives",
NewRequest: "New Request",
CreateCommitteeRequest: "Create Committee Request",
CreateInternalRequest: "Create Internal Request",
InternalRequestTopics: "Internal Request Topics",
CreateNewRequest: "Create New Request",
RequestTable: "Request Table",
RequestType: "Request Type",
RequestDetail: "Request Detail",
RequestBy: "Request by",
ApplicationNumber: "Application Number",
ForwardStatus: "Forward Status",
ViewAction: "View Action",
InProgress: "In Progress",
AdditionalInfoRequested: "Additional Info Requested",
AssignedToProsecutor: "Assigned to Prosecutor",
Registered: "Registered",
ResubmitSummaryWrittenComments: "Re-submit Summary Written Comments",
RequestForLegislativeDrafting: "Request for Legislative Drafting",
Accepted: "Accepted",
NotYetAccepted: "Not yet accepted",
Rejected: "Rejected",
UnderRevision: "Under revision",
Approved: "Approved",
Recommended: "Recommended",
Published: "Published",
Archived: "Archived",
CurrentStatus: "Current Status",
broadcasted: "Broadcasted",
draft_approved: "Draft Approved",
draft_submitted: "Draft Submitted",
final_approval: "Final Approval",
forwarded_to_coordinator: "Forwarded To Coordinator",
forwarded_to_director: "Forwarded To Director",
legal_draft_approved: "Legal Draft Approved",
published: "Published",
submitted: "Submitted",  
team_setup: "Team Setup",
additional_info_submitted: "Additional Information submitted",
additional_info_response_submitted: "Additional Info response submitted",
coordinator_remark_submitted: "Coordinator remark submitted",
director_remark_submitted: "Director remark submitted",
Researcher: "Researcher",
Member: "Member",
Members: "Members",
Coordinator: "Coordinator",
Prosecutor: "Prosecutor",
TeamLeader: "Team Leader",
is_team_leader: "Team Leader",
IsTeamLeader: "is Team Leader",
RegNumber: "Reg Number",
ResearchTopic: "Research Topic",
Abstract: "Abstract",
ResearchDraftSummary: "Research Draft Summary",
NoSummaryAvailable: "No summary available",
Summary: "Summary",
EditSummary: "Edit Summary",
EnterSummaryPlaceholder: "Enter summary...",
SummaryOfComments: "Summary of Comments",
SummaryOfWrittenComments: "Summary of Written Comments",
SummaryWritten: "Summary Written",
summary_of_comments: "Summary of Comments",
summary_updated_success: "Summary updated successfully!",
PreviousVersions: "Previous Versions",
previous_version_one: "previous version",
previous_version_other: "previous versions",
ViewTeam: "View Team",
ResearchFinding: "Research Finding",
CheckingAccuracyOfSectorDirectives: "Checking the Accuracy of Sector Directives",
RequestForCheckingAccuracyOfSectorDirectives: "Request for Checking the Accuracy of Sector Directives",
SectorDirectiveAccuracyCheck: "Sector Directive Accuracy Check",
RequestLetter: "Request Letter",
DirectiveFile: "Directive File",
AdditionalInfoDoc: "Additional Info Doc",
AmendedFile: "Amended File",
AmendedLegislativeFile: "Amended Legislative File",
CompletionLetter: "Completion Letter",
CompletionLetterFile: "Completion Letter File",
UploadCompletionLetter: "Upload Completion Letter",
FeedbackFile: "Feedback File",
RespondBackFile: "Respond Back File",
ReplaceWrittenCommentsFile: "Replace Written Comments File (optional)",
WrittenComments: "Written Comments",
NoDocumentsUploadedYet: "No documents uploaded yet.",
AllDocuments: "All Documents",
NoProposalSummaryProvided: "No proposal summary provided.",
ProposalSubmitted: "Proposal Submitted",
ProposalApprovedSuccess: "Proposal approved successfully!",
SavedSuccessfully: "Saved successfully!",
ForwardedSuccess: "Forwarded successfully!",
ForwardedSuccessfully: "Forwarded successfully!",
AdditionalInfoSubmittedSuccess: "Additional Info Submitted successfully!",
FeedbackSubmittedSuccess: "Feedback submitted successfully!",
LegislativeFeedbackSubmittedSuccess: "Legislative Feedback submitted successfully!",
LegislativeDraftForwardedSuccess: "Legislative Draft Forwarded successfully!",
RespondBackSubmitted: "Respond Back Submitted",
CannotForwardBeforeEditing: "Cannot forward before editing.",
CannotRemoveOnlyTeamLeader: "Cannot remove the only team leader. Please assign a new team leader first or add another member.",
PleaseAddTeamMemberBeforeForwarding: "Please add at least one team member before forwarding to prosecutor.",
SetupTeamMembers: "Setup Team Members",
SelectProsecutor: "Select Prosecutor",
AddSelectedProsecutorToTeam: "Add Selected Prosecutor to Team",
NoTeamMembersAdded: "No team members added yet. Please add at least one.",
NoTeamMembersAddedYet: "No team members added yet.",
TeamList: "Team List",
ProsecutorAlreadyAdded: "This prosecutor is already added to the team.",
ApprovalAndForward: "Approval and Forward",
ForwardToCoordinator: "Forward To Coordinator",
ForwardToDirector: "Forward To Director",
ForwardToProsecutors: "Forward To Prosecutors",
SetupTeamAndForwardToProsecutor: "Setup Team & Forward to Prosecutor",
FinalApproveDraftLaw: "Final Approve Draft Law",
BroadcastToPublicWebsite: "Broadcast to Public Website",
Feedback: "Feedback",
PublicFeedback: "Public Feedback",
RespondBack: "Respond back",
RespondBackFeedback: "Respond Back Feedback",
AdditionalInformationRequest: "Additional Information Request",
AdditionalInformationResponse: "Additional Information Response",
RequestForAdditionalInfo: "Request for Additional Info",
DirectorRemark: "Director Remark",
DetailHere: "Detail here...",
NoFeedbackYet: "No feedback yet.",
SendFeedback: "Send Feedback",
RegistrarActions: "Registrar Actions",
LetterReferenceNumber: "Letter Reference Number",
LetterReferenceNumberPlaceholder: "Eg. 12345",
Selected: "Selected",
additional_info_summary: "Additional Info Summary",
additional_info_response_note: "Additional Info Response Note",
requested_document_detail: "Requested Document Detail",
Address: "Address",
search_title: "Search Legal Researches",
search_label: "Search by reference number",
search_placeholder: "Enter reference number...",
searching: "Searching...",
search_button: "Search",
results_count: "{{count}} results found for \"{{term}}\"",
loading_message: "Loading research papers...",
no_results_found: "No results found for \"{{term}}\"",
no_data_yet: "No research papers available yet.",
search_translation_papers_title: "Search for Translation Papers",
loading_translation_data: "Loading translation data...",
no_translation_papers_yet: "No legal translation papers have been submitted yet",
select_translation_paper_details: "Select a translation paper to view details",
search_failed: "Search failed",
failed_to_fetch_legal_translation: "Failed to fetch Legal Translation request.",
search_public_register_directives: "Search for Public Register Directives",
search_by_ref_num_or_org: "Search by reference number or organization.",
loading_public_directives: "Loading public directives...",
no_public_register_directives_yet: "No public register directives available yet",
select_directive_to_view_details: "Select a directive to view details",
SelectResearchPaperToViewDetails: "Select a research paper to view details",
NoteText: "Please ensure all required documents are uploaded and fields are filled accurately for the sector directive accuracy check.",
NoteSubtext: "The request letter and directive file must be provided, along with reference number and explanatory notes.",
DocumentRequirementsTitle: "Document Requirements for Checking Sector Directives Accuracy",
DocumentRequirementsDescription: "Ensure all required documents and information are provided to process your request for checking the accuracy of sector directives.",
FailedToFetchLegalResearchRequest: "Failed to fetch legal research request.",
FailedToFetchStakeholder: "Failed to fetch stakeholder",
FailedToFetchEmployees: "Failed to fetch employees.",
FailedToFetchSectorDirectives: "Failed to fetch sector directives.",
FailedToRequestAdditionalInformation: "Failed to request additional information.",
FailedToUpdateApproval: "Failed to update approval.",
FailedToUpdateDraft: "Failed to update draft.",
FailedToUpdateLegalResearchRequest: "Failed to update legal research request.",
FailedToUpdateSectorDirectiveRequest: "Failed to update Sector Directive request.",
FailedToUpdateSummary: "Failed to update summary.",
FailedToUpdateRequest: "Failed to update request.",
FailedToUpdateLegislativeDraftRequest: "Failed to update Legislative Draft request.",
FailedToUploadFile: "Failed to upload file.",
ErrorFetchingDirectiveRequests: "Error fetching Directive requests:",
FailedToFetchDirectiveRequests: "Failed to fetch Directive requests.",
SearchFailed: "Search failed",
ExplanatoryNote: "Explanatory Note",
Stakeholder: "Stakeholder",
RemarkForDirector: "Remark For Director",
RemarkForCoordinator: "Remark For Coordinator",
RemarkForProsecutor: "Remark For Prosecutor",
Broadcasted: "Broadcasted",
Approve: "Approve",
letter_ref_number_required: "Please enter a letter reference number",
explanatory_notes_required: "Please enter explanatory notes",
letter_required: "Request letter is required",
file_required: "Directive file is required",
fill_all_fields: "Please fill all required fields",
request_success: "Request submitted successfully",
request_failed: "Failed to submit request",
send_request: "Send Request",
note_text: "Please ensure all required documents are uploaded and fields are filled accurately for the sector directive accuracy check.",
note_subtext: "The request letter and directive file must be provided, along with reference number and explanatory notes.",
requirements_title: "Document Requirements for Checking Sector Directives Accuracy",requirements_desc: "Ensure all required documents and information are provided to process your request for checking the accuracy of sector directives.",
letter_ref_number_label: "Letter Reference Number",
letter_ref_number_placeholder: "Eg. 12345",
explanatory_notes_label: "Explanatory Notes",
request_title: "Request for Checking Accuracy of Sector Directives",
submit_request_desc_alt: "Submit a new request for sector directive accuracy verification",
AdditionalInfoSummary: "Additional Info Summary",
AddAdditionalInfo: "Add Additional Info",
NoMessagesYet: "No Messages Yet",
NoRespondBackFeedbackYet: "No Respond Back Feedback Yet",
WrittenCommentsFile: "Written Comments File",
RequestedDocumentDetail: "Requested Document Detail",
LegalResearchProposalApproved: "Legal research proposal Approved!",
FailedToUpdateLegalResearchProposalApproval: "Failed to update legal research proposal Approval.",
RequestForAdditionalInfoTitle: "Request For Additional Information",
ResearchDataPublishedPublic: "Research Data Published Public",
NoImplementationDirectionAvailable: "No implementation direction available",
TeamLeaderAvatarAlt: "Team Leader Avatar",
Unknown: "Unknown",
PlusMoreMembers: "+ {{count}} more",
MemberCount: "{{count}} Member",
MemberCount_plural: "{{count}} Members",
PageneshTwoItems: "Pagenesh: 2 Items",
PageneshCount: "Pagenesh: {{count}}",
PleaseProvideSummaryOrFile: "Please provide a summary or upload a file",
ResearchUpdatedSuccessfully: "Research updated successfully",
FailedToUpdateResearch: "Failed to update research",
ReuploadResearchDraftFile: "Reupload Research Draft File",
ResearchDraftFile: "Research Draft File",
LatestResearchDraft: "Latest Research Draft",
VersionNumber: "Version {{version}} - {{date}}",
ResearchDataPublished: "Research Data Published",
PublishDraftLegislationForPublic: "Publish Draft Legislation For Public",
LastUpdated: "Last updated",
NoDraftSummaryAvailable: "No draft summary available",
PreviousVersion: "Previous Version",
PreviousVersion_plural: "Previous Versions",
PublishedLegalDraftsPublic: "Published Legal Drafts : Public Reg Number",
NoDraftInstructionSummaryAvailable: "No draft instruction summary available",
LegislativeDrafter: "Legislative Drafter",
Verified: "Verified",
search_drafting_papers_title: "Search for Drafting Papers",
search_drafting_papers_label: "Search by reference number, organization, or summary...",
search_drafting_papers_placeholder: "Eg. 12345, organization name, draft summary...",
loading_drafting_data: "Loading drafting data...",
no_legal_drafting_papers_yet: "No legal drafting papers have been submitted yet",
select_drafting_paper_to_view: "Select a drafting paper to view details",
BroadcastStatusUpdated: "Broadcast status updated",
FailedToUpdateBroadcastStatus: "Failed to update broadcast status",
FailedToFetchLegalDraftingPapers: "Failed to fetch legal drafting papers.",
broadcast_draft_legislation_title: "Broadcast Draft Legislation to Public",
broadcast_draft_legislation_description: "Share your completed legal draft with the public to increase transparency and accessibility. Broadcasting makes the draft visible to all users and stakeholders.",
broadcast_draft_legislation_additional_info: "Once broadcasted, the draft will be publicly accessible and can be viewed by anyone. You can unpublish it later if needed.",
OfficialLegalTranslationPublished: "Official Legal Translation Published",
NoTranslationSummaryAvailable: "No translation summary available",
LegalTranslator: "Legal Translator",
TranslatedFile: "Translated File",
PleaseSelectAtLeastOneFile: "Please select at least one file to upload.",
PleaseEnterReferenceNumberForCompletion: "Please enter a reference number for the completion letter.",
FilesUploadedSuccessfully: "Files uploaded successfully!",
FailedToUploadFiles: "Failed to upload files.",
UploadFiles: "Upload Files",
ReferenceNumberForCompletionLetter: "Reference Number (for completion letter)",
EnterReferenceNumber: "Enter reference number",
DraftTranslationFileOptional: "Draft Translation File (optional)",
SelectDraftFile: "Select Draft File",
TranslationCompletionLetterOptional: "Translation Completion Letter (optional)",
SelectCompletionLetter: "Select Completion Letter",
Hide: "Hide",
Show: "Show",
LegallyTranslatedAndPublished: "Legally Translated and Published:",
FailedToFetchLegalTranslation: "Failed to fetch legal translation request.",
Saving: "Saving...",
previous_version: "previous version",
previous_version_plural: "previous versions",
StakeholderType: "Stakeholder Type",
Email: "Email",
SummaryWrittenComments: "Summary Written Comments",
LegalResearchForwardedSuccess: "Legal research forwarded successfully!",
UpdatedAdditionalInformation: "Updated Additional Information",
DraftLawUploaded: "Draft Law Uploaded",
FailedToUploadDraftLaw: "Failed to upload Draft Law.",
DraftLaw: "Draft Law",
DraftLawFile: "Draft Law File",
AdditionalInformationRequested: "Additional Information Requested",
MessengerDetail: "Messenger Detail",
FileTooLargeMessage: "File is too large. Maximum size allowed per file is {{size}}MB.",
TotalFileTooLargeMessage: "Total file size is too large. Maximum total size allowed is {{size}}MB.",
LegislativeDraftSentSuccess: "Legislative draft sent successfully!",
FailedToSendLegislativeDraft: "Failed to send Legislative draft request.",
LegislativeDraftingSubtitle: "Lorem Ipsum is a placeholder text commonly used in the design and publishing industries as a temporary filler.",
RequestLetterReferenceNumber: "Request Letter Reference Number",
DraftInstructionSummary: "Draft Instruction Summary",
RequestLetterRequired: "Request Letter*",
DraftInstructionRequired: "Draft Instruction*",
SelectOrganization: "Select Organization",
DocumentRequirements: "Document Requirements",
LegalResearchRespondedBackSuccess: "Legal research responded back successfully!",
DraftLawDetail: "Draft Law Detail",
LatestLawDraft: "Latest Law Draft",
PreviousDraft: "Previous Draft",
DraftInstruction: "Draft Instruction",
SubmitReferenceNumber: "Submit Reference Number",
LegalDraftingCompletionLetter: "Legal Drafting Completion Letter",
AmendedDraftFile: "Amended Draft File",
SubmitFiles: "Submit Files",
WaitingAdditionalInfo: "Waiting Additional Info",
DraftLawNotEssential: "Draft Law Not Essential",
File: "File",
AdditionalInfoFile: "Additional Info File",
Forwarding: "Forwarding...",
ReDraftLaw: "ReDraft Law",
NonEssential: "Non Essential",
BroadcastLegislativeDraftToPublic: "Broadcast Legislative Draft to Public",
BroadcastLegislativeDraftDescription: "Share your completed legislative draft with the public to increase transparency and accessibility. Broadcasting makes the draft visible to all users and stakeholders.",
BroadcastLegislativeDraftAdditionalInfo: "Once broadcasted, the draft will be publicly accessible and can be viewed by anyone. You can unpublish it later if needed.",
EnterDraftSummary: "Draft summary...",
ReuploadDraftFileOptional: "Re-upload Draft File (optional)",
Version: "Version",
LatestAmendedLawFile: "Latest Amended Law File",
PreviousAmendedLawFiles: "Previous Amended Law Files",
LatestPublicFeedbackFile: "Latest Public Feedback File",
PreviousPublicFeedbackFiles: "Previous Public Feedback Files",
SubmitPublicFeedback: "Submit Public Feedback",
UploadAmendedLegislativeFile: "Upload Amended Legislative File",
AuditSummary: "Audit Summary",
AuditDocument: "Audit Document",
UploadAuditLegislativeDraft: "Upload Audit Legislative Draft",
AllowPublicFeedback: "Allow Public Feedback",
RegisterNumber: "Register Number",
LatestDraftLawFile: "Latest Draft Law File",
NoComment: "No Comment",
ConfirmBroadcast: "Confirm Broadcast",
ConfirmBroadcastMessage: "Are you sure you want to broadcast this legislative draft to the public website? This action cannot be undone.",
Broadcast: "Broadcast",
PleaseProvideRemark: "Please provide a remark before responding back.",
SessionExpired: "Your session has expired. Please log in again.",
PleaseWriteRemarkBeforeForwarding: "Please write a remark before forwarding.",
ForwardedToCoordinatorSuccess: "Forwarded to Coordinator successfully!",
FailedToForwardRequest: "Failed to forward request.",
TeamSetupAndForwardedSuccess: "Team setup and forwarded to Prosecutor successfully!",
ailedToFetchLegalTranslation: "Failed to fetch legal translation request.",
LegalTranslationRequest: "Legal Translation Request",
LegalTranslationSubtitle: "Provide the necessary documents and information to request a professional legal translation.",
SupportingDocumentsForTranslationRequired: "Supporting Documents for Translation*",
EnterReferenceNumberPlaceholder: "Enter reference number (e.g., #12345)",
SummaryOfTranslationRequest: "Summary of Translation Request",
SummaryOfTranslationRequestPlaceholder: "Provide a concise description of the documents and purpose of the translation...",
SubmitRequest: "Submit Request",
OfficialRequestLetter: "Official Request Letter",
RequestLetterReferenceNumberRequired: "Request Letter Reference Number is required",
SummaryOfTranslationRequestRequired: "Summary of Translation Request is required",
AppliedDateRequired: "Applied Date is required",
OfficialRequestLetterRequired: "Official Request Letter is required",
SupportingDocumentsRequired: "Supporting Documents for Translation is required",
PleaseFillAllRequiredFields: "Please fill in all required fields",
LegalTranslationRequestSubmittedSuccess: "Legal Translation request submitted successfully!",
FailedToSubmitLegalTranslationRequest: "Failed to submit Legal Translation request.",
ImportantNotes: "Important Notes",
ImportantNotesText: "Ensure all required documents are properly attached before submitting.",
ImportantNotesSubtext: "Incomplete submissions may result in processing delays or rejection.",
CertifiedLegalDocuments: "Certified Legal Documents",
ContractsAgreementsLegalNotices: "Contracts, Agreements, and Legal Notices",
LegislativeDraftsPolicyDocuments: "Legislative Drafts and Policy Documents",
LegalTranslationDetails: "Legal Translation Details",
RegisterLetterNumber: "Register Letter Number",
LegalTranslationSummaryNote: "Legal Translation Summary Note",
TranslationCompletionLetter: "Translation Completion Letter",
LetterReferenceNumberAndCompletionLetterUploaded: "Letter Reference Number and Completion Letter uploaded successfully!",
FailedToUploadLetterReferenceNumberAndCompletionLetter: "Failed to upload Letter Reference Number and Completion Letter.",
SetupTeamMembersOptional: "Setup Team Members (Optional)",
NoTeamMembersAddedYetOptional: "No team members added yet. Optional if forwarding to Coordinator.",
RemarkSavedSuccess: "Remark saved successfully!",
FailedToSaveRemark: "Failed to save remark.",
SaveOnly: "Save Only",
RequestForwardedSuccess: "Request forwarded successfully!",
EditTeam: "Edit Team",
AddNewTeamMember: "Add New Team Member",
Loading: "Loading...",
SearchProsecutors: "Search prosecutors...",
NoAvailableProsecutorsFound: "No available prosecutors found",
AddMember: "Add Member",
Adding: "Adding...",
NoTeamMembersFound: "No team members found",
SetAsTeamLeader: "Set as Team Leader",
RemoveMember: "Remove Member",
CloseAndRefresh: "Close & Refresh",
LegalDepartment: "Legal Department",
FailedToLoadAvailableProsecutors: "Failed to load available prosecutors.",
TeamLeaderUpdatedSuccess: "Team leader updated successfully!",
FailedToUpdateTeamLeader: "Failed to update team leader.",
ConfirmRemoveTeamMember: "Are you sure you want to remove this team member?",
TeamMemberRemovedSuccess: "Team member removed successfully!",
FailedToRemoveTeamMember: "Failed to remove team member.",
PleaseSelectTeamMember: "Please select a team member.",
TeamMemberAddedSuccess: "Team member added successfully!",
FailedToAddTeamMember: "Failed to add team member.",
CreatedBy: "Created By",
BroadcastTranslationToPublic: "Broadcast Translation to Public",
BroadcastTranslationDescription: "Share your completed legal translation with the public to increase transparency and accessibility. Broadcasting makes the translation visible to all users and stakeholders.",
BroadcastTranslationAdditionalInfo: "Once broadcasted, the translation will be publicly accessible and can be viewed by anyone. You can unpublish it later if needed.",
ForwardToZone: "Forward To Zone",
Edit: "Edit",
PreviousDrafts: "Previous Drafts",
PreviousDrafts_plural: "Previous Drafts",
ProsecutorAssignmentsTeam: "Prosecutor Assignments / Team",
NoProsecutorsAssigned: "No prosecutors/team assigned yet.",
DirectorOptions: "Director Options",
DirectorOptionsDescription: "Choose an option: setup team and forward to prosecutors, or just submit remark and forward to coordinator.",
LegalTranslationBroadcasted: "Legal translation broadcasted to public!",
LegalTranslationUnpublished: "Legal translation unpublished!",
DraftLegalTranslation: "Draft Legal Translation",
TranslationSummary: "Translation Summary",
LegalTrainingProvisionRequest: "Legal Training Provision Request",
LegalTrainingProvisionSubtitle: "Submit a formal request outlining institutional legal training needs and required supporting documents.",
RequestLetterReferenceNumberPlaceholder: "e.g. LTP/REQ/2025/014",
LegalTrainingNeedsDescription: "Description of Legal Training Needs *",
LegalTrainingNeedsDescriptionPlaceholder: "Describe the training objectives, target participants, and expected institutional outcomes.",
LegalTrainingNeedsDescriptionRequired: "Description of legal training needs is required.",
SupportingTrainingDocument: "Supporting Training Document *",
SupportingTrainingDocumentRequired: "Supporting training document is required.",
SubmitTrainingRequest: "Submit Training Request",
LegalTrainingRequestUpdatedSuccess: "Legal training request updated successfully!",
LegalTrainingRequestSubmittedSuccess: "Legal training provision request submitted successfully!",
FailedToSubmitLegalTrainingRequest: "Failed to submit legal training request.",
SubmissionGuidelines: "Submission Guidelines",
SubmissionGuidelinesText: "Ensure all required documents and adequate justification are provided.",
SubmissionGuidelinesSubtext: "Incomplete submissions may be returned for revision.",
LegalTrainingUpdatedSuccess: "Legal Training Updated successfully!",
Internal: "Internal",
RequestForLegalTrainingProvision: "Request for Legal Training Provision",
LegalTrainingProvisionFormSubtitle: "Please fill out the form below to submit a legal training provision request.",
SelectStakeholder: "Select Stakeholder",
Topic: "Topic",
TopicPlaceholder: "Eg. Training topic",
TrainingSummary: "Training Summary",
TrainingSummaryPlaceholder: "Eg. Training summary",
SummaryFile: "Summary File",
LegalTrainingProvisionUpdatedSuccess: "Legal training provision updated successfully!",
LegalTrainingProvisionSubmittedSuccess: "Legal training provision request submitted successfully!",
FailedToSubmitLegalTrainingProvision: "Failed to submit legal training provision request.",
LegalTrainingProvisionNoteText: "Provide all required details for the legal training provision request.",
LegalTrainingProvisionNoteSubtext: "Ensure the selected stakeholder is correct before submitting.",
LegalTrainingProvisionDocRequirementsDesc: "Include supporting documents like legal research notes or legislative drafts.",
ConfirmSubmission: "Confirm Submission",
ConfirmSubmissionMessage: "Are you sure you want to submit this legal training provision request? Once submitted, it cannot be edited.",
FailedToFetchStakeholders: "Failed to fetch stakeholders.",
LegalAwarenessReport: "Legal Awareness Report",
TrainingReport: "Training Report",
LegalAwarenessReportSummary: "Summary of Legal Awareness Report",
TrainingReportSummary: "Summary of Training Report",
LegalAwarenessReportDoc: "Legal Awareness Report Doc*",
TrainingReportDoc: "Training Report Doc*",
TrainingReportUploaded: "Training Report Uploaded",
FailedToUploadTrainingReport: "Failed to upload Training Report.",
TrainingOutcome: "Training Outcome",
TrainingFeedback: "Training Feedback",
TrainingManual: "Training Manual",
SummaryOfTrainingOutcome: "Summary of Training Outcome",
SummaryOfFeedback: "Summary of Feedback",
SummaryOfTrainingManual: "Summary of Training Manual",
TrainingOutcomeDoc: "Training Outcome Doc*",
FeedbackDoc: "Feedback Doc*",
TrainingManualDoc: "Training Manual Doc*",
TrainingManualUploaded: "Training Manual Uploaded",
FailedToUploadTrainingManual: "Failed to upload Training Manual.",
AddTrainingManual: "Add Training Manual",
FailedToSubmit: "Failed to submit",
TrainingSentFrom: "Training sent from {{adminUnit}}",
RequestLetterNumber: "Request Letter Number",
ReUploadTrainingReport: "ReUpload Training Report",
UploadTrainingReport: "Upload Training Report",
FailedToFetchZones: "Failed to fetch zones.",
PleaseSelectAtLeastOneZone: "Please select at least one zone.",
ZoneAlreadyDistributed: "Zone {{zoneName}} has already been distributed to. Skipping.",
ForwardedToZonesSuccess: "Forwarded to selected zones successfully!",
DistributeToZone: "Distribute To Zone",
SelectZones: "Select Zones",
NoZonesAvailable: "No zones available",
SelectedZonesCount: "Selected Zones ({{count}}):",
RemoveZone: "Remove zone",
ForwardToZones: "Forward To Zones ({{count}})",
ConfirmDistribution: "Confirm Distribution",
ConfirmDistributionMessage: "Are you sure you want to distribute to {{count}} selected zone(s)? This action will forward the request to the zonal offices.",
Distribute: "Distribute",
TeamAssignmentsUpdatedSuccess: "Team assignments updated successfully!",
LegalTrainingRequestForwardedSuccess: "Legal Training Request Forwarded successfully!",
FailedToUpdateLegalTrainingRequest: "Failed to update Legal Training request.",
TrainingTopicSummary: "Training Topic Summary",
LatestVersion: "Latest Version",
TrainingManualSummary: "Training Manual Summary",
EditTrainingManual: "Edit Training Manual",
TrainingOutcomeSummary: "Training Outcome Summary",
TrainingFeedbackDocument: "Training Feedback Document",
TrainingReportFor: "Training Report for {{zone}}",
Submitted: "Submitted",
NotSubmitted: "Not Submitted",
ReportNotSubmittedYet: "Report Not Submitted Yet",
TrainingReportNotUploadedMessage: "The training report for this zone has not been uploaded. Please check back later or contact the relevant team.",
TrainingSchedule: "Training Schedule",
InPerson: "In-Person",
Online: "Online",
Hybrid: "Hybrid",
Schedule: "Schedule",
ReUploadTrainingOutcome: "ReUpload Training Outcome",
UploadTrainingOutcome: "Upload Training Outcome",
ReUploadTrainingFeedback: "ReUpload Training Feedback",
UploadTrainingFeedback: "Upload Training Feedback",
Directive: "Directive",
LegalAwareness: "Legal Awareness",
LegalAwarenessTable: "Legal Awareness Table",
SentDate: "Sent Date",
ZoneProsecutor: "Zone Prosecutor",
FailedToFetchLegalAwarenessRequest: "Failed to fetch legal awareness request.",
AssignProsecutor: "Assign Prosecutor",
AddToTeam: "Add to Team",
ListOfTopic: "List of Topic",
EnterTopicPlaceholder: "Enter topic",
TargetAudience: "Target Audience",
EnterTargetAudiencePlaceholder: "Enter target audience",
SubmittingLegalAwarenessRequest: "Submitting Legal Awareness Request...",
LegalAwarenessRequestUpdatedSuccess: "Legal Awareness Request updated successfully!",
LegalAwarenessRequestCreatedSuccess: "Legal Awareness Request created successfully!",
FailedToCreateLegalAwarenessRequest: "Failed to create Legal Awareness Request. Please try again.",
PleaseEnterTopic: "Please enter a Topic.",
PleaseEnterTargetAudience: "Please enter a Target Audience.",
PleaseAddAtLeastOneTeamMember: "Please add at least one team member.",
PleaseSelectExactlyOneTeamLeader: "Please select exactly one team leader for the team.",
FailedToLoadProsecutors: "Failed to load prosecutors. Please refresh the page.",
UploadEvidence: "Upload Evidence",
EvidenceSummary: "Evidence Summary",
CollectedEvidence: "Collected Evidence",
EvidenceCollectors: "Evidence Collectors",
CollectorNamePlaceholder: "Enter collector name...",
AddEvidenceCollector: "Add Evidence Collector",
NoCollectorsAddedYet: "No evidence collectors added yet. Please add at least one.",
RemoveCollector: "Remove collector",
EvidenceCollectionTeamSubmitted: "Evidence Collection team Submitted!",
EvidenceDataUploaded: "Evidence Data Uploaded",
FailedToUploadEvidenceData: "Failed to upload evidence data.",
LegalAwarenessOutcome: "Legal Awareness Outcome",
LegalAwarenessCreationSummary: "Legal Awareness Creation Summary",
OutcomeOfAwareness: "Outcome of Awareness",
LegalAwarenessSummary: "Legal Awareness Summary",
OutcomeOfAwarenessDoc: "Outcome of Awareness Doc*",
LegalAwarenessDoc: "Legal Awareness Doc*",
LegalAwarenessUploaded: "Legal Awareness Uploaded",
FailedToUploadLegalAwareness: "Failed to upload Legal Awareness.",
ReUploadLegalAwarenessSummary: "ReUpload Legal Awareness Summary",
UploadLegalAwarenessSummary: "Upload Legal Awareness Summary",
ReUploadAwarenessOutcome: "ReUpload Awareness Outcome",
UploadAwarenessOutcome: "Upload Awareness Outcome",
SeminarScheduleUpdatedSuccess: "Seminar Schedule updated successfully!",
FailedToUpdateSeminarSchedule: "Failed to update Seminar Schedule.",
LegalAwarenessSummaryUpdated: "Legal Awareness Summary updated successfully!",
FailedToUpdateLegalAwarenessSummary: "Failed to update Legal Awareness Summary.",
LegalAwarenessForwardedSuccess: "Legal Awareness Forwarded successfully!",
FailedToUpdateLegalAwarenessRequest: "Failed to update Legal Awareness request.",
SeminarSchedule: "Seminar Schedule",
UpdateSchedule: "Update Schedule",
RequestDetails: "Request Details",
Topics: "Topics",
AwarenessOutcome: "Awareness Outcome",
AwarenessOutcomeSummary: "Awareness Outcome Summary",
LegalAwarenessDocumentFile: "Legal Awareness Document File",
LegalAwarenessDocument: "Legal Awareness Document",
LatestDocument: "Latest Document",
PreviousDocuments: "Previous Documents",
UpdateSummary: "Update Summary",
AwarenessReportFor: "Awareness Report for {{zone}}",
AwarenessReportSummary: "Awareness Report Summary",
AwarenessReportNotUploadedMessage: "The awareness report for this zone has not been uploaded. Please check back later or contact the relevant team.",
ConfirmAction: "Confirm Action",
ConfirmActionMessage: "Please review all entered information carefully. Once confirmed, this action will be submitted and cannot be modified.",
Confirm: "Confirm",
IdentificationCompleted: "Identification Completed",
EnterLocation: "Enter location",
ScheduledDateTime: "Scheduled Date and Time",
Location: "Location",
LegalAdviceCompletionLetter: "Legal Advice Completion Letter",
RequestForLegalAdvisory: "Request for Legal Advisory",
LegalAdvisorySubtitle: "Lorem Ipsum is a placeholder text commonly used in the design and publishing industries as a temporary filler.",
LegalAdvisoryRequestRequired: "Legal Advisory Request*",
LegalAdvisoryRequestDocument: "Legal Advisory Request Document",
LegalAdvisorySentSuccess: "Legal Advisory request sent successfully!",
FailedToSendLegalAdvisory: "Failed to send Legal Advisory request.",
LegalAdvisoryNoteText: "Please ensure all required documents are uploaded and information is accurately provided for your Legal Advisory request.",
LegalAdvisoryNoteSubtext: "The Legal Advisory process helps in obtaining expert legal opinions and guidance on specific legal matters.",
LegalRequestSummary: "Legal Request Summary",
LegalRequestSummaryRequired: "Legal Request Summary is required",
SummaryUpdatedSuccess: "Summary updated successfully!",
LatestAdviceFile: "Latest Advice File",
PreviousFiles: "Previous Files",
ResponseFile: "Response File",
LegalAdvice: "Legal Advice",
LegalAdvisoryForwardedSuccess: "Legal Advisory Forwarded successfully!",
FailedToUpdateLegalAdvisoryRequest: "Failed to update Legal Advisory request.",
SearchByReferenceNumber: "Search by reference number,...",
Searching: "Searching...",
Search: "Search",
ResultsCount: "{{count}} result(s) for \"{{term}}\"",
LoadingLawImplementationData: "Loading law implementation data...",
NoResultsFound: "No results found for \"{{term}}\"",
NoLawImplementationPapersYet: "No law implementation papers have been submitted yet",
SelectLawImplementationToViewDetails: "Select a law implementation paper to view details",
FailedToFetchPublicLawImplementation: "Failed to fetch public law implementation data.",
LawImplementationFollowUp: "Law Implementation Follow-Up",
FollowupDate: "Follow-up Date",
SectorRequest: "Sector Request",
ZonalRequest: "Zonal Request",
CreateLawImplementationRequest: "Create Law Implementation Request",
CreateRequestDescription: "Fill in the details below to create a new law implementation follow-up request with team assignments.",
BasicInformation: "Basic Information",
AuditTarget: "Audit Target",
AuditTargetPlaceholder: "Enter the law or government sector to identify",
Description: "Description",
DescriptionPlaceholder: "Provide detailed description of the request...",
TeamSetup: "Team Setup",
TeamName: "Team Name",
TeamNamePlaceholder: "Enter team name (e.g., Team Alpha)",
CreateTeam: "Create Team",
AddTeamMembers: "Add Team Members",
Add: "Add",
CurrentTeamMembers: "Current Team Members ({{count}})",
CreatedTeams: "Created Teams ({{count}})",
MembersCount: "{{count}} member(s)",
PleaseEnterTeamName: "Please enter a team name.",
PleaseAddTeamMemberBeforeCreatingTeam: "Please add at least one team member before creating a team.",
TeamNameAlreadyExists: "A team with this name already exists.",
PleaseSelectProsecutorFirst: "Please select a prosecutor first.",
PleaseEnterAuditTarget: "Please enter the Audit Target.",
PleaseEnterRemark: "Please enter a Remark.",
PleaseAddAtLeastOneTeam: "Please add at least one team.",
TeamMustHaveMembers: "Team \"{{teamName}}\" must have at least one member.",
TeamMustHaveLeader: "Team \"{{teamName}}\" must have a team leader.",
TaskCreatedSuccess: "Legal research Task created and prosecutors assigned!",
FailedToSendRequest: "Failed to send legal research request.",
UploadWoredaReport: "Upload Woreda Report",
Woreda: "Woreda",
SummaryOfWoredaReport: "Summary of Woreda Report*",
EnterReportSummaryPlaceholder: "Enter report summary...",
ReportDocument: "Report Document*",
SubmitReport: "Submit Report",
PleaseProvideReportSummary: "Please provide a report summary.",
PleaseSelectReportFile: "Please select a report file.",
WoredaReportUploadedSuccess: "Woreda Report Uploaded Successfully!",
FailedToUploadWoredaReport: "Failed to upload woreda report.",
UploadEnforcementAnalysis: "Upload Enforcement Analysis",
EnforcementAnalysisFile: "Enforcement Analysis File",
CurrentFile: "(current file)",
EnforcementAnalysisSummary: "Enforcement Analysis Summary",
EnterEnforcementAnalysisSummaryPlaceholder: "Enter enforcement analysis summary...",
Upload: "Upload",
EnforcementAnalysisUploadedSuccess: "Enforcement Analysis uploaded successfully!",
FailedToUploadEnforcementAnalysis: "Failed to upload enforcement analysis.",
Audit: "Audit",
UploadIdentifiedLawOrSector: "Upload Identified Law or Sector",
EnforcementAnalysisDocument: "Enforcement Analysis Document*",
TargetName: "Target Name",
EnterTargetNamePlaceholder: "Enter target name",
AddTarget: "Add Target",
AddedTargets: "Added Targets",
NoTargetsAddedYet: "No targets added yet",
AddAtLeastOneTargetToContinue: "Add at least one target to continue",
RemoveTarget: "Remove target",
PleaseAddAtLeastOneTarget: "Please add at least one Target.",
OnlyTeamLeadersCanAddTargets: "Only team leaders can add targets.",
EnterDetailedSummaryPlaceholder: "Enter detailed summary here...",
LawImplementationUploaded: "Law Implementation Uploaded",
FailedToUploadLawImplementation: "Failed to upload Law Implementation.",
TeamUpdatedSuccess: "Team updated successfully!",
FailedToUpdateTeam: "Failed to update team. Please try again.",
EditTeamDetails: "Edit Team Details",
EnterTeamNamePlaceholder: "Enter team name",
TeamNameWillBeUpdated: "Team name will be updated",
TeamLeaderWillBeChanged: "Team leader will be changed",
SelectTeamLeader: "Select team leader",
SelectedLeader: "Selected Leader",
PendingChanges: "Pending Changes",
UpdateTeamNameTo: "Update team name to",
ChangeTeamLeaderTo: "Change team leader to",
Updating: "Updating...",
UpdateTeam: "Update Team",
IdentifiedLawSectors: "Identified Law Sectors ({{count}})",
AcceptedTargets: "Accepted Targets ({{count}}):",
SubmitAcceptedTargets: "Submit Accepted Targets",
UnknownTeam: "Unknown Team",
SubmittedBy: "Submitted by",
Accept: "Accept",
NotAccepted: "Not Accepted",
ViewAudit: "View Audit",
LawImplementationPublished: "Law Implementation Published",
NoDescriptionAvailable: "No description available",
AuditFindings: "Audit Findings",
ImplementationTeam: "Implementation Team",
ViewTeamMembers: "View Team Members",
AttachedDocuments: "Attached Documents",
UploadAuditTarget: "Upload Audit Target",
InsertEvidence: "Insert Evidence",
InsertEnforcementAnalysis: "Insert Enforcement Analysis",
RegistrarArchiveSection: "Registrar Archive Section",
AuditFindingsFiles: "Audit Findings Files",
SaveAndArchive: "Save & Archive",
ArchiveDetailsSubmittedSuccess: "Archive details submitted successfully!",
FailedToArchiveRequest: "Failed to archive request.",
LegalAwarenessForZoneImplementation: "Legal Awareness For Zone Implementation",
LegalAwarenessSentFrom: "Legal Awareness sent from {{adminUnit}}",
DistributedWoredas: "Distributed Woredas",
Sent: "Sent",
UploadReport: "Upload Report",
DistributeToWoreda: "Distribute to Woreda",
ReUploadLegalAwarenessReport: "ReUpload Legal Awareness Report",
UploadLegalAwarenessReport: "Upload Legal Awareness Report",
RequestForLawImplementation: "Request for Law Implementation",
AuditTargetOverview: "Audit Target Overview",
TeamSubmissionStatus: "Team Submission Status",
NotAssigned: "Not Assigned",
Pending: "Pending",
EnforcementAnalysis: "Enforcement Analysis",
OfficialDocument: "Official Document",
AttachedFile: "Attached File",
UpdateFile: "Update File",
NoEnforcementAnalysisFile: "No enforcement analysis file uploaded.",
AuditExecutionDetail: "Audit Execution Detail",
AuditFinding: "Audit Finding",
SectorFeedback: "Sector Feedback",
SectorFeedbackSummary: "Sector Feedback Summary",
NoSectorFeedbackFile: "No sector feedback file available.",
CollectorsList: "Collectors List",
CollectorsTeam: "Collectors Team",
Evidence: "Evidence",
History: "History",
DistributeToWoredaDescription: "Distribute the legal awareness to Woreda offices within your zone.",
SelectWoredas: "Select Woredas",
NoWoredasAvailable: "No woredas available",
SelectedWoredasCount: "Selected Woredas ({{count}}):",
RemoveWoreda: "Remove woreda",
Processing: "Processing...",
DistributeToWoredasButton: "Distribute To Woredas ({{count}})",
PleaseSelectAtLeastOneWoreda: "Please select at least one woreda.",
DistributedToWoredasSuccess: "Distributed to selected woredas successfully!",
FailedToDistributeToWoredas: "Failed to distribute to woredas.",
ConfirmDistributionToWoredas: "Confirm Distribution",
ConfirmDistributionToWoredasMessage: "Are you sure you want to distribute to {{count}} selected woreda(s)? This action will forward the request to the woreda offices.",
LawImplementationUnpublished: "Law implementation unpublished!",
BroadcastLawImplementationDescription: "Share this law implementation progress with the public. Broadcasting makes the progress visible to all users and stakeholders on the public website.",
BroadcastLawImplementationAdditionalInfo: "Once broadcasted, the details will be publicly accessible. You can unpublish it later if needed.",
Law: "Law",
ShowEvidences: "Show Evidence's",
AllEvidence: "All Evidence:",
EvidenceNumber: "Evidence #{{number}}",
FileCount: "{{count}} file(s)",
FileCount_plural: "{{count}} files",
CollectorCount: "{{count}} collector(s)",
CollectorCount_plural: "{{count}} collectors",
NoAuditFindingsFile: "No audit findings file available.",
AuditDocuments: "Audit Documents",
Dashboard: "Dashboard",
DashboardSubtitle: "Overview of your legal research and implementation activities",
TotalRequests: "Total Requests",
ActiveTasks: "Active Tasks",
Completed: "Completed",
PendingReview: "Pending Review",
ChangeFromLastMonth: "{{change}} from last month",
ServiceOverview: "Service Overview",
ServiceOverviewSubtitle: "Current status of all legal services",
LegalResearchRequestTypes: "Legal Research Request • Committee Request",
DraftLegislationRequests: "Draft legislation requests",
LegalAdviceRequests: "Legal advice requests",
SectorDirectiveReviews: "Sector directive reviews",
DirectiveRegistrationRequests: "Directive registration requests",
ExternalInternal: "External • Internal",
External: "External",
ImplementationMonitoring: "Implementation monitoring",
PublicAwarenessCampaigns: "Public awareness campaigns",
TrainingPrograms: "Training programs",
QuickActions: "Quick Actions",
NavigateToServices: "Navigate to services",
requests: "requests",
ErrorLoadingDashboardData: "Error loading dashboard data",
// SingleConductLegalResearch Component
OfficialLegalResearchRequestPortal: "Official Legal Research Request Portal",
LegalResearchPortalSubtitle: "Secure platform for submitting and managing legal research requests within the Office of the Attorney General and Department of Justice.",
ForwardToOfficeOfAttorneyGeneral: "Forward to Office of the Attorney General",
RegistrarLetterReferenceNumber: "Registrar Letter Reference Number",
ResearchAbstract: "Research Abstract",
HeadOfOAGBResponseFeedback: "Head of OAGB Response Feedback",
RelatedServices: "Related Services",
RelatedServicesDescription: "Explore additional legal services and documentation available through our platform.",
ConductingLegalResearch: "Conducting Legal Research",
ResearchBroadcastedToPublic: "Research broadcasted to public!",
ResearchUnpublished: "Research unpublished!",
LegalResearchForwardedToDirector: "Legal research request Forwarded to Director!",
LegalResearchRequestSentSuccess: "Legal research request sent successfully!",
FailedToSendLegalResearchRequest: "Failed to send legal research request.",
YesContinue: "Yes, Continue",
ConfirmForwardToAttorneyGeneralMessage: "Are you sure you want to forward this request to the Office of the Attorney General? This action will update the status and cannot be undone.",
RequestForConductingLegalResearch: "Request for Conducting Legal Research",
LegalResearchSubtitle: "Lorem Ipsum is a placeholder text commonly used in the design and publishing industries as a temporary filler.",
SubmitToOAGB: "Submit to OAGB",
ForwardToProsecutor: "Forward to Prosecutor",
CommitteeRequestSummary: "Committee Request Summary",
ResearchCompletionLetterFile: "Research Completion Letter File",
LegalResearchForwardedToProsecutor: "Legal research request Forwarded to Prosecutor!",
CreateNewRequestSubtitle: "Submit the official request letter and research synopsis to initiate legal research.",
ResearchDetail: "Research Detail",
LetterReferenceNumberRequired: "Letter Reference Number *",
ReasonForLegalRequestRequired: "Reason for Legal Request *",
ResearchTopicRequired: "Research Topic *",
ResearchTopicAbstractRequired: "Research Topic Abstract *",
ResearchSynopsisRequired: "Research Synopsis *",
SelectReason: "Select reason",
EnterResearchTopic: "Enter research topic",
ProvideResearchTopicAbstract: "Provide research topic abstract",
LegalResearchRequestUpdatedSuccess: "Legal research request updated successfully!",
LegalResearchRequestSubmittedSuccess: "Legal research request submitted successfully!",
FailedToSubmitLegalResearchRequest: "Failed to submit legal research request.",
ResearchSynopsis: "Research Synopsis",
SupportingDocuments: "Supporting documents (if any)",
DateRequired: "Date is required.",
ResearchCommitteeSupportSummaryRequired: "Research Committee Support Summary *",
CommitteeRequestFileRequired: "Committee Request File *",
ResearchRequestTask: "Research Request Task",
ReasonForLegalRequest: "Reason for Legal Request",
TypesHere: "Types Here",
ResearchTopics: "Research Topics",
AddSelectedTopic: "Add Selected Topic",
NoTopicAddedYet: "No Topic added yet. Please add at least one.",
PleaseAddAtLeastOneTopic: "Please add at least one Topic.",
ResearchInformation: "Research Information",
ResearchTask: "Research Task",
TaskPlaceholder: "#Task",
CancelEdit: "Cancel Edit",
MemberCountAdded: "{{count}} member added",
MemberCountAdded_plural: "{{count}} members added",
CreateTeamWithCount: "+ Create Team ({{count}})",
PleaseEnterResearchTask: "Please enter a research task.",
PleaseCreateAtLeastOneTeam: "Please create at least one team before submitting.",
EachTeamMustHaveTeamLeader: "Each team must have a team leader selected.",
PleaseSelectTeamLeader: "Please select a team leader before creating a team.",
PleaseSelectTeamLeaderWarning: "⚠️ Please select a team leader for this team before creating it.",
OtherTeamsCount: "📋 {{count}} other team (cancel editing to manage)",
OtherTeamsCount_plural: "📋 {{count}} other teams (cancel editing to manage)",
TeamLeaderCheck: "Team Leader ✓",
StakeHolderInfo: "Stake Holder Info",
StakeHolderAddress: "Stake Holder Address",
ResearchInformations: "Research Informations",
NamePlaceholder: "Eg. Abebe",
SubcityZone: "Subcity / Zone",
SubcityZonePlaceholder: "Eg. Addis Abeba",
AddressPlaceholder: "Eg. Worda | Kebele",
WoredaDistrict: "Woreda / District",
WoredaDistrictPlaceholder: "Eg. Addis Abebax",
Kebele: "kebele",
KebelePlaceholder: "Eg. Addis Abeba",
PhoneNumberPlaceholder: "0912421241",
EmailPlaceholder: "info@gmail.com",
EmailRequired: "Email is required",
ValidEmailRequired: "Please enter a valid email address",
HouseNumber: "House Number",
HouseNumberPlaceholder: "Eg. 123",
ResearchTopicPlaceholder: "#123",
ResearchTopicAbstract: "Research Topic Abstract",
SendRequestAgain: "Send Request Again",
ProposalDocument: "Proposal Document",
ForwardedToCoordinator: "Forwarded to Coordinator!",
FailedToForward: "Failed to forward.",
InternalRequest: "Internal Request",
ExternalRequest: "External Request",
CommitteeRequest: "Committee Request",
ScheduledPresentation: "Scheduled Presentation",
ExternalRequestList: "External Request List",
ExternalNewRequest: "External New Request",
ExternalScheduledPresentation: "External Scheduled Presentation",
CommitteeRequestList: "Committee Request List",
CommitteeNewRequest: "Committee New Request",
CommitteeScheduledPresentation: "Committee Scheduled Presentation",
PublishedResearch: "Published Research",
InternalPublished: "Internal Published Research",
ExternalPublished: "External Published Research",
CommitteePublished: "Committee Published Research",
LegalResearchRequest: "Legal Research Request",
ProposalSubmission: "Proposal Submission",
InternalResearchTask: "Internal Research Task",
CreatedDate: "Created Date",
RegistrationNumber: "Registration Number",
TitlePresentation: "Title Presentation",
ResearchAvatarAlt: "Research avatar",
SearchByApplicationNumber: "Search by Application Number...",
Table: "Table",
Logout: "Logout",
Logo: "Logo",
OrganizationName: "Biiroo Abbaa Alangaa W.O.",
OrganizationNameAmharic: "ቢሮዎ አባ አላንጋ ወ.ኦ.",
Reports: "Reports",
ResearchLawDraftingFollowup: "Research, Law Drafting & Followup",
PoweredBy: "Powered by EAII",
UploadProposalTitle: "Upload Proposal",
UploadProposalDescription: "Submit your legal research proposal for review",
ProposalSummary: "Proposal Summary",
ProposalSummaryPlaceholder: "Describe your proposal details, objectives, and methodology...",
ProposalFile: "Proposal File",
SubmitProposal: "Submit Proposal",
Letter: "Letter",
AssignedCoordinator: "Assigned Coordinator",
LevelOfUrgency: "Level of Urgency",
RemarkOfHeadOfOAGB: "Remark of Head of OAGB",
UploadProposal: "Upload Proposal",
ApproveButton: "Approve Button",
PresentationScheduleDate: "Presentation Schedule Date",
HallNumber: "Hall Number",
AssignCoordinator: "Assign Coordinator",
SelectCoordinator: "Select Coordinator",
Assign: "Assign",
ProsecutorAssignedSuccess: "Prosecutor assigned successfully!",
FailedToAssignProsecutor: "Failed to assign prosecutor.",
BroadcastResearchToPublic: "Broadcast Research to Public",
BroadcastResearchDescription: "Share your completed legal research with the public to increase transparency and accessibility. Broadcasting makes the research visible to all users and stakeholders.",
BroadcastResearchAdditionalInfo: "Once broadcasted, the research will be publicly accessible and can be viewed by anyone. You can unpublish it later if needed.",
CurrentlyPublished: "Currently Published",
NotPublished: "Not Published",
Unpublishing: "Unpublishing...",
Broadcasting: "Broadcasting...",
Unpublish: "Unpublish",
BroadcastToPublic: "Broadcast to Public",
Team: "Team",
UnexpectedResponseFormat: "Unexpected response format when fetching topics.",
FailedToFetchInternalLegalResearchTopicRequest: "Failed to fetch internal legal research topic request.",
TopicsApproved: "Topics Approved",
FailedToUpdateTitleApproval: "Failed to update legal research Title Approval.",
TitleApprovedSuccess: "Legal research Title Approved!",
ProposalFeedbackSubmittedSuccess: "Legal research proposal feedback submitted successfully!",
FailedToUpdateProposalFeedback: "Failed to update legal research proposal Feedback.",
ProposalRejectedSuccess: "Legal research proposal rejected!",
FailedToUpdateProposalApproval: "Failed to update legal research proposal Approval.",
AddFeedBack: "Add FeedBack",
DeadlineForProposal: "Deadline For Proposal",
DayUntilPresentation: "day until presentation",
DayUntilPresentation_plural: "days until presentation",
ProposalPresentation: "Proposal Presentation",
ScheduledForPresentation: "Scheduled for presentation",
UrgentAttentionRequired: "⚠️ Urgent - Immediate Attention Required",
TopicPresentations: "Topic Presentations",
Scheduled: "Scheduled",
Presentation: "Presentation",
ClickToEditView: "Click to {{action}} presentation details",
ViewEditDetails: "View/Edit Details",
EditPresentation: "Edit Presentation",
ImplementationDirection: "Implementation Direction",
ProposalFileSummary: "Proposal File Summary",
LatestProposalFile: "Latest Proposal File",
PreviousProposalFiles: "Previous Proposal Files",
Proposal: "Proposal",
ScheduleProposalPresentation: "Schedule Proposal Presentation",
TitleApprovalRemark: "Title Approval Remark",
RemarkFromManagement: "Remark from management",
RemarkOfDirector: "Remark of Director",
RemarkOfCoordinator: "Remark of coordinator",
ScheduleTopicsPresentation: "Schedule {{type}} Presentation",
ScheduleTopicPresentation: "Schedule Topic Presentation",
EditTopicPresentation: "Edit Topic Presentation",
High: "High",
Medium: "Medium",
Low: "Low",
SetLevelOfUrgency: "Set level of urgency",
AssignProsecutors: "Assign Prosecutor/s",
TitleRemarkFromManagement: "Title Remark from management",
LegalResearchDraftRejected: "Legal research Draft Rejected",
FailedToRejectLegalResearchDraft: "Failed to Reject legal research Draft.",
LegalResearchForwardedToDirectorSuccess: "Legal research forwarded to Director successfully!",
FailedToForwardLegalResearchToDirector: "Failed to forward legal research to Director.",
LegalResearchApprovedByDirector: "Legal research approved by Director successfully!",
FailedToApproveLegalResearch: "Failed to approve legal research.",
LegalResearchDraftApproved: "Legal research Draft Approve successfully!",
FailedToApproveLegalResearchDraft: "Failed to Approve legal research Draft.",
ResearchPresentationFeedback: "Research Presentation Feedback",
ForwardToRegistrar: "Forward to Registrar",
ForwardToManagement: "Forward to Management",
ResearchFeedbackFile: "Research Feedback File",
SubmitImplementationDirection: "Submit Implementation Direction",
ResearchDraftPresentation: "Research Draft Presentation",
DateNotScheduled: "Date not scheduled",
DraftHistory: "Draft History",
Draft: "Draft",
ResearchData: "Research Data",
ViewResearchData: "View Research Data",
ResearchDataCollectors: "Research Data Collectors",
GatheredBy: "Gathered By",
InsertData: "Insert Data",
UploadResearchDraft: "Upload Research Draft",
ProsecutorDraftInstruction: "As the team leader, insert the collected research data, then upload the research draft for review.",
AddData: "Add Data",
EditResearchData: "Edit Research Data",
LegalResearchDataUpdated: "Research data updated.",
UploadPresentationFeedback: "Upload Presentation Feedback",
ScheduleResearch: "Schedule Research",
FeedbackFromManagement: "FeedBack From Management",
RemarkFile: "Remark File",
Reject: "Reject",
SubmitFeedback: "Submit FeedBack",
ConductLegalResearchRequest: "Conduct Legal Research Request",
CloseReport: "Close Report",
CloseTopicSubmission: "Close Topic Submission",
ProposalSummaryUpdatedSuccess: "Proposal summary updated successfully!",
FailedToUpdateProposalSummary: "Failed to update proposal summary.",
ReuploadProposal: "Re-upload Proposal",
EnterProposalSummaryPlaceholder: "Enter proposal summary...",
SaveSummary: "Save Summary",
ReUploadProposalFile: "Re-upload Proposal File",
CurrentProposalFile: "Current Proposal File",
NoProposalFileAvailable: "No proposal file available",
AssessmentSummary: "Assessment Summary",
RequestSummary: "Request Summary",
FindingAssessment: "Finding Assessment",
OfficialReports: "Official Reports",
Latest: "Latest",
CommitteeReport: "Committee Report",
ReportNumber: "Report {{number}}",
Approving: "Approving...",
ResearchAmendedFile: "Research Amended File",
LegalResearchApprovedAndForwardedToRegistrar: "Legal research approved by Director successfully and forwarded to Registrar!",
ApproveAndForwardToRegistrar: "Approve and Forward to Registrar",
ApproveAndForwardToDirector: "Approve and Forward to Director",
ApproveAndForwardToHead: "Approve and Forward to Head",
EditAmendedFile: "Edit Amended File",
RegistrarRegistration: "Registry Registration",
RegistrarRegistrationDescription: "Record the official registry reference and attach the completion letter to finalize this research request.",
LetterReferenceNumberHint: "The official registry reference number assigned to this request.",
ResearchCompletionLetterHint: "Upload the signed official completion letter to be delivered to the requesting body.",
ResearchAmendedFileHint: "Optionally attach the final amended research document.",
MessengerNameHint: "Name of the person collecting the official completion letter.",
CompleteRegistration: "Complete Registration",
RegistrationCompleted: "Registration Completed",
FetchingOfficialStamp: "Fetching official stamp…",
StampingDocuments: "Stamping documents…",
StampNotice: "The uploaded documents will be officially stamped with the Office of the Attorney General service stamp upon submission.",
ResearchAmendedFileViewHint: "The latest amended research document. It will be officially stamped on submission.",
LegalResearchApprovedAndForwardedToHead: "Draft approved and forwarded to Head.",
ForwardingToDirector: "Forwarding to Director...",
ResearchDraft: "Research Draft",
PreviousDraftFiles: "Previous draft files",
EditDraft: "Edit / Re-upload",
ResearchPresentationFeedbackTitle: "Research Presentation Feedback",
PresentationFeedback: "Presentation Feedback",
AmendedResearchFinding: "Amended Research Finding",
LegalResearchDraftUploaded: "Legal research Draft Uploaded",
FailedToUploadLegalResearchDraft: "Failed to upload legal research Draft.",
RequestFiles: "Request Files",
WriteYourFeedbackHere: "Write Your Feedback here",
Sending: "Sending...",
FeedbackNotSubmitted: "Feedback not submitted successfully",
ApprovalAndSettingAppointmentForResearchDraftPresentation: "Approval and Setting Appointment For Research Draft Presentation",
ScheduleUpdatedSuccess: "Schedule updated successfully!",
ScheduleCreatedSuccess: "Schedule created successfully!",
ApprovalAndSettingAppointmentForTitlePresentation: "Approval and Setting Appointment For Title Presentation",
EditTrainingSchedule: "Edit Training Schedule",
TrainingMethod: "Training Method",
SelectMethod: "Select Method",
TrainingScheduleUpdatedSuccess: "Training schedule updated successfully!",
ScheduleForwardedSuccess: "Schedule forwarded successfully!",
FailedToUpdateSchedule: "Failed to update Schedule.",
// SettingUpTeamModal Component
AssembleResearchTeam: "Assemble Research Team",
CommitteeReviewTeamAssignment: "Committee Review Team Assignment",
SelectAndAssignProsecutors: "Select and assign prosecutors to research team",
TeamComposition: "Team Composition",
AddProsecutorToTeam: "Add Prosecutor to Team",
SelectFromAvailableProsecutors: "Select from available Legal Research Prosecutors",
TeamMembersCount: "Team Members ({{count}})",
AddProsecutorsToAssembleTeam: "Add prosecutors to assemble your team",
LeaderCheck: "Leader ✓",
MakeLeader: "Make Leader",
ProposalDeadline: "Proposal Deadline",
SetProposalDeadlineDescription: "Set the deadline for proposal submission",
TeamInstructionsAndRemarks: "Team Instructions & Remarks",
TeamInstructionsPlaceholder: "Provide instructions, special requirements, or notes for the team...",
TeamInstructionsOptional: "Optional: Add guidance or special instructions for the assigned team",
ConfidentialTeamAssignment: "Confidential Team Assignment",
AssigningTeam: "Assigning Team...",
ConfirmTeamAssignment: "Confirm Team Assignment",
TeamAssignedSuccess: "Team assigned successfully!",
FailedToAssignTeam: "Failed to assign team.",
PleaseSelectProsecutorToAdd: "Please select a prosecutor to add.",
ProsecutorAlreadyInTeam: "This prosecutor is already in the team.",
PleaseSetProposalDeadline: "Please set a proposal deadline.",
ResearchTopicsDescription: "Manage and review research proposals",
ResearchTopicsCount: "Research Topics ({{count}})",
TeamSubmissionStatusDescription: "Track team participation and submissions",
DaysOverdue: "days overdue",
Today: "Today!",
DaysRemaining: "days remaining",
ForwardedToCoordinatorCount: "Forwarded to Coordinator ({{count}})",
NotForwardedCount: "Not Forwarded ({{count}})",
TopicTitleCannotBeEmpty: "Topic title cannot be empty.",
TopicUpdatedSuccessfully: "Topic updated successfully.",
FailedToUpdateTopic: "Failed to update topic.",
TopicAddedSuccessfully: "Topic added successfully.",
FailedToAddTopic: "Failed to add topic.",
ConfirmRemoveTopic: "Are you sure you want to remove this topic?",
TopicRemoved: "Topic removed.",
FailedToRemoveTopic: "Failed to remove topic.",
TopicPrioritiesUpdated: "Topic priorities updated successfully.",
FailedToUpdateTopicPriorities: "Failed to update topic priorities.",
RequestForwardedToCoordinator: "Request forwarded to coordinator.",
TopicsAcceptedAndForwarded: "Topics accepted and forwarded to coordinator.",
NewTopicTitle: "New Topic Title",
EnterTopicTitle: "Enter topic title...",
SaveTopic: "Save Topic",
Created: "Created",
OverdueByDays: "Overdue by {{count}} days",
DaysLeft: "{{count}} days left",
ViewResearch: "View Research",
FindingAssessmentDescription: "Review attached assessment document",
NoLocationSpecified: "No location specified",
NoRemarks: "No remarks",
Overdue: "overdue",
Left: "left",
EditTopic: "Edit topic",
RemoveTopic: "Remove topic",
LegalResearchProposalUploaded: "Legal research Proposal Uploaded",
FailedToUploadLegalResearchProposal: "Failed to upload legal research Proposal.",
ReportSummary: "Report Summary",
ReportFile: "Report File",
UploadResearchData: "Upload Research Data",
DataName: "Data Name",
DataSummary: "Data Summary",
DataFile: "Data File",
InsertDataCollectors: "Insert Data Collectors",
AddDataCollectorToTeam: "Add Data Collector to Team",
PleaseAttachDataFile: "Please attach a data file.",
LegalResearchProsecutorsAssigned: "Legal research prosecutors assigned!",
LegalResearchDataUploaded: "Legal research Data Uploaded",
FailedToUploadLegalResearchData: "Failed to upload legal research Data.",
DraftFile: "Draft File",
  // Dashboard
  rd_dashboard: "Dashboard",
  rd_welcome_back: "Welcome back",
  rd_overview: "Here is an overview of the requests in your work lists.",
  rd_view_all: "View all",
  rd_load_failed: "Could not load this list",
  rd_recent: "Recent",
  rd_no_data: "Nothing to show yet",
  rd_loading: "Loading...",
  rd_no_modules: "There are no work lists for your role.",
  rd_in_your_list: "In your list",
  rd_workload_by_module: "Workload by service",
  rd_items: "Items",
  rd_by_status: "by status",
  rd_waiting_for_you: "Waiting for your action",
  rd_nothing_waiting: "Nothing is waiting for your action.",
  CheckingAccuracyOfSectors: "Checking Accuracy of Sector Directives",
  RegisteringDirectives: "Registering Directives",
};

export default en;
